export default function DashboardVerifikatorSklPage() {
  return <div>DashboardVerifikatorSklPage</div>;
}
